import { CONTINUOUS_EDUCATION } from '../../../api/endpoints';
import request from '../../../api/request';
import { Section } from '../../../api/requests/MantainerPortal';
import {
  PaginationQueryDto,
  PaginationRequestType,
} from '../../../types/paginationRequestType';
import { NonStructuredSectionFilters, NonStructuredSectionForm } from './types';

export const getNonStructuredSectionsActionRequest = (
  params: PaginationQueryDto<NonStructuredSectionFilters>,
) => {
  return request<PaginationRequestType<Section>>(
    CONTINUOUS_EDUCATION.SECTIONS_PAGINATED,
    {
      params: {
        ...params,
        page: params.page - 1,
      },
    },
  );
};

export const getNonStructuredSectionsFormActionRequest = () => {
  return request<NonStructuredSectionForm>(CONTINUOUS_EDUCATION.SECTIONS_FORM);
};
